/**
 * Prefixe göre key filtreleme için pattern oluşturur
 * @param {string} prefix - Filtrelenecek prefix
 * @returns {RegExp} Filtreleme deseni
 */
export const createPattern = (prefix) => {
  return new RegExp(`^${prefix}(:.*)?$`)
}